import { render, staticRenderFns } from "./PdvMaps.vue?vue&type=template&id=05fbbe2a&scoped=true"
import script from "./PdvMaps.vue?vue&type=script&lang=js"
export * from "./PdvMaps.vue?vue&type=script&lang=js"
import style0 from "./PdvMaps.vue?vue&type=style&index=0&id=05fbbe2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fbbe2a",
  null
  
)

export default component.exports